'use strict';

module.exports = 60 * 1000;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/var/MINUTES.js
// module id = 288
// module chunks = 0